import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
var render = function render() {
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('x-popup', {
        class: [
            'credit-retain-container',
            _vm.$style["bg".concat(_vm.step)]
        ],
        style: {
            width: '75%'
        },
        attrs: {
            "value": _vm.value,
            "title": "",
            "safeAreaInsetBottom": true,
            "close-on-click-overlay": false,
            "position": "center",
            "closeable": "",
            "close-icon-position": "top-right",
            "teleport": "body",
            "round": ""
        },
        on: {
            "click-close-icon": _setup.clickCloseBtn
        }
    }, [
        _c('div', {
            class: _vm.$style.content
        }, [
            _c('div', {
                class: [
                    _vm.$style.smallCircleCommon,
                    _vm.$style["smallCircle".concat(_vm.step)]
                ]
            }),
            _c('p', {
                class: _vm.$style.title
            }, [
                _vm._v(_vm._s(_setup.currentObj.title))
            ]),
            _c('p', {
                class: _vm.$style.description
            }, [
                _vm.step === 1 ? [
                    _vm._v(" " + _vm._s(_setup.currentObj.description[0]) + " "),
                    _c('span', {
                        class: _vm.$style.money
                    }, [
                        _vm._v("$" + _vm._s(_setup.formatAmount(_setup.currentObj.money, '0,0')))
                    ]),
                    _vm._v(" " + _vm._s(_setup.currentObj.description[1]) + " ")
                ] : [
                    _vm._v(" " + _vm._s(_setup.currentObj.description) + " ")
                ]
            ], 2),
            _c('img', {
                class: _vm.$style.stepImg,
                attrs: {
                    "src": _setup.currentObj.stepImg,
                    "alt": ""
                }
            }),
            _c('van-button', {
                class: _vm.$style.yesBtn,
                style: {
                    color: '#fff'
                },
                attrs: {
                    "native-type": "button",
                    "block": ""
                },
                on: {
                    "click": function($event) {
                        return _setup.clickContinueBtn();
                    }
                }
            }, [
                _vm._v(" Seguir ")
            ]),
            _c('van-button', {
                class: _vm.$style.noBtn,
                style: {
                    color: '#003333'
                },
                attrs: {
                    "native-type": "button"
                },
                on: {
                    "click": function($event) {
                        return _setup.emit('show-second');
                    }
                }
            }, [
                _vm._v(" Salir ")
            ])
        ], 1)
    ]);
};
var staticRenderFns = [];
export { render, staticRenderFns };
